export default __webpack_public_path__ + "static/media/token-icon-3.a1f6513a.svg";